/** Sections render in the server's order, each drawn from its payload. */
import { type ReactNode } from 'react'
import type { ShopifyStudyBuilderEvaluationResponse } from '@testfeed/shopify-contracts'
import { studyBuilderSectionAnchorId, useStudyBuilderSectionLink } from '../../hooks/outside/useStudyBuilderSectionLink'
type Sections = ShopifyStudyBuilderEvaluationResponse['sections']
export function StudyBuilderSections({
  sections,
  renderBlocks,
}: {
  sections: Sections
  renderBlocks: (section: Sections[number]) => ReactNode
}) {
  const root = useStudyBuilderSectionLink(sections)
  return (
    <div ref={root}>
      <s-stack direction="block" gap="large-200">
        {sections.map((section) => (
          <div key={section.id} id={studyBuilderSectionAnchorId(section.id)} data-study-builder-section={section.id}>
            <s-stack direction="block" gap="large-200">
              {renderBlocks(section)}
            </s-stack>
          </div>
        ))}
      </s-stack>
    </div>
  )
}
